import { render, staticRenderFns } from "./editDictType.vue?vue&type=template&id=791dc9de&"
import script from "./editDictType.vue?vue&type=script&lang=js&"
export * from "./editDictType.vue?vue&type=script&lang=js&"
import style0 from "./editDictType.vue?vue&type=style&index=0&id=791dc9de&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports